import React from 'react';
import { NavLink } from 'react-router-dom';
import { MdOutlineAttachMoney } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";

import './layout.css';

const AddAccountLayout = ({ children }) => {

  
 
  return (
    <div className='container-fluid'>
      <h1 className="layouts-title">
      <IoMdAdd className="leave-policy-icon" />
        Add Accounts
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="add-account-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/add-account"
              >
                <MdOutlineAttachMoney className="nav-icon" />Account
              </NavLink>
            </li>
           
          </ul>
        </div>
        <div className="content">
          {children}
        </div>
      </section>
    </div>
  );
};

export default AddAccountLayout;
